<template>
  <div class="content-box">
    <fieldset>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.term.id') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.terminalid" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.term.in.msg') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.inputlen | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.term.out.msg') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.outputlen | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row><v-col cols="12" style="height:29px"></v-col></v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.clnt') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.mandt" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.task.type') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.tasktype" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.wp.no') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.wpid" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.trxn.id') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.transid" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.sssn.id') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.contextId" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.diag.step') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.dialogStep | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row><v-col cols="12" style="height:29px"></v-col></v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.batch.input.que.time') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.queti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.rfc.interf.time') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.rfcti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.ddic.interf.time') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.ddicti | millis | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row><v-col cols="12" style="height:29px"></v-col></v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.tot.mem.used') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.memsum | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.max.mem') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.maxroll | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.alloc.mem') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.maxpage | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <fieldset>
            <!-- eslint-disable-next-line prettier/prettier -->
            <legend><span>{{ $t('ssr.title.max.ext') }}</span></legend>
            <v-row>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-col cols="4"><p class="label">{{ $t('ssr.title.in.trxn') }}</p></v-col>
              <v-col cols="8"><v-text-field :value="mainrec.maxbytes | comma" outlined dense hide-details readonly></v-text-field></v-col>
            </v-row>
            <v-row>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-col cols="4"><p class="label">{{ $t('ssr.title.in.diag') }}</p></v-col>
              <v-col cols="8"><v-text-field :value="mainrec.maxbytesdi | comma" outlined dense hide-details readonly></v-text-field></v-col>
            </v-row>
          </fieldset>
        </v-col>
      </v-row>
      <v-row><v-col cols="12" style="height:29px"></v-col></v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.ext.mem') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.usedbytes | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.priv.mem') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.privsum | comma" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.wp.priv.mode') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.privmode" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-col cols="4"><p class="label">{{ $t('ssr.title.wp.restart') }}</p></v-col>
        <v-col cols="8"><v-text-field :value="mainrec.wprestart" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
    </fieldset>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import tabable from './tabable';

export default {
  mixins: [tabable],
  computed: {
    ...mapState('analysis/ssr', ['mainrec']),
  },
};
</script>

<style lang="scss" scoped>
@import './tab';
</style>
